import { el, setAttr, setChildren } from 'redom';

import {
  getGenerationStatus,
  getLastAction,
  formatActionType,
  hasContent
} from './utilities';

import {
  spinner
} from './spinner';

var STATUSES = {
  STARTED: 'STARTED',
  WORKING: 'WORKING',
  STREAMING: 'STREAMING'
};

class GenerationStateDisplay {

  constructor() {

    this.el = el('.generation-state-container');

  }

  showStarted() {

    setChildren(this.el, [spinner.cloneNode(true)]);
    setAttr(this.el, { style: { display: 'flex' } });

  }

  showWorking(message) {

    var lastAction = getLastAction(message);
    var labelText = lastAction !== null ? formatActionType(lastAction) : '';

    setChildren(this.el, [
      spinner.cloneNode(true),
      el('label.generation-action-label', labelText)
    ]);
    setAttr(this.el, { style: { display: 'flex' } });

  }

  hide() {

    setChildren(this.el, []);
    setAttr(this.el, { style: { display: 'none' } });

  }

  update(message) {

    var status = getGenerationStatus(message);

    if (status === STATUSES.STARTED) {
      this.showStarted();
      return false;
    }

    if (status === STATUSES.WORKING) {
      this.showWorking(message);
      return false;
    }

    if (status === STATUSES.STREAMING && hasContent(message) === false) {
      this.showStarted();
      return false;
    }

    this.hide();
    return true;

  }

}

export default GenerationStateDisplay;